<template>
  <TopCard v-if="posts" :method="setAlbum" :post="posts[0]"/>
  <GridDisplay title="Recomendados para ti" :method="setAlbum" :posts="posts" />
</template>

<script>
import TopCard from '@/components/TopCard.vue';
import GridDisplay from '@/components/GridDisplay.vue'
export default {
  components: {TopCard, GridDisplay},
  name: 'AlbumsView',
  data(){
    return{
      posts: [],
    }
  },
  mounted(){
    if(localStorage.getItem('token')!== null){
      const url = this.baseUrl + '/user/me/recommendations/albums?access_token=' + localStorage.getItem('token');
      fetch(url)
        .then(response=>response.json())
        .then(json=>this.posts = json.data);
    }
    else{
      const url = this.baseUrl + '/chart/0/albums'
      fetch(url)
        .then(response=>response.json())
        .then(json=>this.posts = json.data);
    }   
  },
  methods:{
    setAlbum(a){
      if(typeof a !== 'undefined'){
        const tracklistUrl = a.tracklist.slice(22)
        fetch(this.baseUrl + tracklistUrl)
          .then(response=>response.json())
          .then(json=> localStorage.setItem('currentSong', JSON.stringify(json.data[0])));
      }    
    }
  }
}
</script>